
import { LabelItemPrintZoneProps, PrintLabelInfos, PrintTemplateInfos, labelEditorSlice } from 'cdx-common';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState, appStore } from 'store';
import { CurrentLabelItemRenderer, EditableLabelItem, PrintLabelItemRenderer } from './LabelItem';

export const LabelTemplateRenderer = (props: { onClick?: () => void, infos: PrintTemplateInfos, children?: React.ReactNode, isMainEditingLabel?: boolean; }) => {

    const configuration = useSelector((state: RootState) => state.labelEditor.currentLabel?.configuration);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (props.isMainEditingLabel && ref && ref.current) {
            appStore.dispatch(labelEditorSlice.actions.setLabelSizeInPixels({
                width: ref.current.clientWidth,
                height: ref.current.clientHeight
            }));
        }
    }, [props.isMainEditingLabel]);

    const cfg = configuration ?? props.infos.template;

    return <div
        ref={ref}
        style={cfg?.userDefinedDimensions ? {
            width: cfg.userDefinedDimensions.width + 'cm',
            height: cfg.userDefinedDimensions.height + 'cm',
        } : undefined}
        onClick={props.onClick}
        className={'printLabel ' + props.infos.template.labelClassName}>{props.children}{props.infos.template.bg ? <img src={'./assets/labels/templates/' + props.infos.template.bg + '.svg'} /> : null}<div className="printLabelBorders"></div></div>;
};

export const PrintLabelRenderer = (props: { infos: PrintLabelInfos, onClick?: () => void; }) => {
    return <LabelTemplateRenderer onClick={props.onClick} infos={props.infos}>{props.infos.items.map((_p, i) => <PrintLabelItemRenderer key={i} index={i} infos={props.infos} />)}</LabelTemplateRenderer>;
};

export const CurrentLabelRenderer = (props: { offset: number, onClick?: () => void; }) => {

    const template = useSelector((state: RootState) => state.labelEditor.currentLabel?.template);
    const items = useSelector((state: RootState) => state.labelEditor.currentLabel?.items);
    if (!items || !template) return <></>;
    return <LabelTemplateRenderer onClick={props.onClick} infos={{ template: { ...template } }}>{items.map((_p, i) => <CurrentLabelItemRenderer key={i} index={i} offset={props.offset} />)}</LabelTemplateRenderer>;
};

export const EmptyLabel = (props: { onClick?: () => void; }) => {
    const printLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);
    if (!printLabel) return <></>;
    return <div onClick={props.onClick} className={'printLabel ' + printLabel.configuration.labelClassName}>{printLabel.template.bg ?? <img style={{ opacity: 0 }} src={'./assets/labels/templates/' + printLabel.template.bg + '.svg'} />}</div>;
};
export const PlaceholderLabel = () => {
    const currLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);
    return <div
        style={currLabel?.configuration?.userDefinedDimensions ? {
            width: currLabel.configuration.userDefinedDimensions.width + 'cm',
            height: currLabel.configuration.userDefinedDimensions.height + 'cm',
        } : undefined}
        className={'printLabel ' + currLabel?.template.labelClassName}></div>;
};

export const LabelEditingRenderer = () => {

    const printLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);
    const selectedLabelItem = useSelector((state: RootState) => state.labelEditor.selectedLabelItem);
    const item = useSelector((state: RootState) => state.labelEditor?.currentLabel?.items[selectedLabelItem ?? -1]);

    const [initialPos, setInitialPos] = useState<{ x: number, y: number; itemProps?: Partial<LabelItemPrintZoneProps>; } | undefined>();

    useEffect(() => {
        if (item && initialPos && !initialPos.itemProps) {
            setInitialPos((p) => {
                return p ? { ...p, itemProps: { ...item.props } } : undefined;
            });
        }
    }, [item]);



    const onMouseDown = (event: React.MouseEvent<HTMLDivElement>): void => {
        if (event.target instanceof HTMLDivElement) {
            const index = event.target.getAttribute('data-label-index');
            if (index && (parseInt(index) || index === '0')) {
                if (item && parseInt(index) === selectedLabelItem) {
                    setInitialPos({ x: event.clientX, y: event.clientY, itemProps: { ...item.props } });
                    return;
                } else {
                    appStore.dispatch(labelEditorSlice.actions.setSelectedItemLabel(parseInt(index)));
                    setInitialPos({ x: event.clientX, y: event.clientY, itemProps: undefined });
                }
                return;
            }
        }
        appStore.dispatch(labelEditorSlice.actions.setSelectedItemLabel(undefined));
    };
    const onMouseUp = (_event: React.MouseEvent<HTMLDivElement>) => {
        setInitialPos(undefined);
    };
    const onMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
        if (selectedLabelItem !== undefined && item && initialPos && initialPos.itemProps) {
            // move the current label !
            const y: number = Math.round(((initialPos.itemProps?.y ?? 0) + ((event.clientY - initialPos.y))));
            const x: number = Math.round(((initialPos.itemProps?.x ?? 0) + ((event.clientX - initialPos.x))));
            if (x !== item.props.x || y !== item.props.y) {
                appStore.dispatch(labelEditorSlice.actions.updatePrintLabelItemProps({
                    index: selectedLabelItem,
                    props: {
                        x: x,
                        y: y
                    }
                }));

            }
        }
    };

    if (!printLabel) return <></>;

    return <div

        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
    ><LabelTemplateRenderer isMainEditingLabel={true} infos={printLabel}>{printLabel.configuration.userDefinedDimensions ? null : <div className='safeZone'></div>}{printLabel.items.map((_p, i) => <EditableLabelItem key={i} index={i} />)}</LabelTemplateRenderer></div>;
};
